import { useContext, useState, useEffect } from 'react';
import { useHistory } from "react-router-dom"
import { Box, Button } from '@mui/material';
import { ToolContext } from '../../../../core/context/ToolContext';
import { Index as BranchProduct } from './branchProduct/Index';
import { Index as BranchSales } from './branchSales/Index';
import { Index as BranchOrder } from './branchOrder/Index';
import { Index as CustomerSales } from '../../billout/desktop/Index';

export const Index = ({match}) => {
    let loc = match.params.features
    const { tool_state, } = useContext(ToolContext)
    const { compInfo } = {...tool_state}

    const nature = compInfo.data[0]?.nature_id
    const nav = useHistory()
    const [tabs, setTabs] = useState([
        {name:'Branch Product', ref:'branch-product'},
        {name:'Branch Sales', ref:'branch-sales'},
        {name:'Customer Sales', ref:'customer-sales'},
        {name:'Branch Order', ref:'branch-order'}
    ])

    const redirectHandler = async(ref) => {
        if (ref !== loc) {
            nav.push(`/reports/${ref}`)        
        }
    }

    useEffect(() => {
        if (nature !== 23) {
            setTabs(tabs.filter((v) => v.name !== 'Customer Sales'));
        }
        //eslint-disable-next-line
    }, []);

    return (
        <Box display="flex" height="100%" width="100%" px={3}>
            <Box width="100%" height="100%"  display="flex" flexDirection="column" p={3}>
                <Box minHeight="70px" display="flex" flexDirection="column">
                    <Box minHeight="48px" display="grid" gridTemplateColumns="repeat(auto-fill,minmax(150px,1fr))" gap="8px">
                        {tabs?.map((v, k) => (
                            <Box onClick={()=>redirectHandler(v.ref)} key={k} component={Button} disableFocusRipple={true} minWidth="150px" borderRadius={3} display="flex" flexDirection="column" alignItems="center" gap="12px" bgcolor={loc === v.ref ?"primary.main":"#FFFFFF"} color={loc === v.ref ?"#fff":"#283745"} sx={{border:"2px solid #EBEBEB", ':hover':loc === v.ref && {bgcolor:'primary.main', color:'#FFFFFF'}}} >
                                <Box fontSize={12} fontWeight={400} lineHeight="19px" width="100%" sx={{wordBreak: 'break-word'}}>{v.name}</Box>
                            </Box>
                        ))}
                    </Box>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }} py={1}></Box>
                </Box>
                <Components loc={loc} match={match} nature={nature}/>
                <Box minHeight="5px"></Box>
            </Box>
        </Box>
    )
}

const Components = ({loc, match, nature}) => {
    if (loc === 'branch-product') { return <BranchProduct match={match}/>
    }else if (loc === 'branch-sales') { return <BranchSales match={match}/>
    }else if (loc === 'customer-sales') { 
        return nature === 23 && <CustomerSales match={match}/>
    }else if (loc === 'branch-order') { return <BranchOrder match={match}/>
    }else{return 'NOT FOUND'}
}